import { NewDynamicTab } from "../../../components/Page";
import { PowerAnalyticsDefaultDates } from "../../../config/DefaultDates";
import PowerAnalytics from "./PowerMarket/SimulationIndex";

// Title component for the middle of the header
function PowerAnalyticsTitle() {
  return (
    <div className="flex items-center justify-center">
      <span className="text-[#34656D] !text-lg font-medium">
        Power Market & Outage Analysis Dashboard
      </span>
    </div>
  );
}

export default function PowerAnalyticsIndex() {
  return (
    <>
      <NewDynamicTab
        defaultDates={PowerAnalyticsDefaultDates}
        minDate="2024-01-01"
        header="Power Market"
        trendTabs={["Power Market"]}
        middleComponent={<PowerAnalyticsTitle />}
        tabs={{
          "Power Market": <PowerAnalytics />,
        }}
        showTabs={false}
      />
    </>
  );
}

